function findDomForWindow(sourceWindow) {
  var iframes = Array.from(document.getElementsByTagName('iframe'));
  return iframes.find(function (iframe) {
    return iframe.contentWindow === sourceWindow;
  });
}
export { findDomForWindow };